/**
 * Route cũ /workspace/ai-evidence — chuyển sang Trợ lý webinar (tab Chứng cứ).
 */
import { Navigate } from 'react-router-dom'

export default function AIEvidencePage() {
  return <Navigate to="/workspace/ai-court-secretary?section=evidence" replace />
}
